@if (status() !== 'bereit') {
  <app-details-historie-status [status]="status()" [fehlerText]="fehlerText()" (retry)="retry.emit()" />
} @else if (hatVorversion()) {
  <div class="version-diff-list">
    <div class="version-diff-list__kopf">
      <span class="version-diff-list__label">{{ 'common.detailsHistorie.versionen.label' | translate }}</span>
      <span class="version-diff-list__versionen">
        <span class="version-diff-list__version-wort">
          {{ 'common.detailsHistorie.versionen.version' | translate }}
        </span>
        <span class="version-diff-list__pille version-diff-list__pille--alt">{{ vonVersion() }}</span>
        @if (hatZuVersion()) {
          <span class="version-diff-list__pfeil">→</span>
          <span class="version-diff-list__pille version-diff-list__pille--neu">{{ zuVersion() }}</span>
        }
      </span>
    </div>
    <p class="version-diff-list__zusammenfassung">
      <strong class="version-diff-list__anzahl">{{ anzahlSchluessel() | translate: { n: felder().length } }}</strong>
      {{ 'common.detailsHistorie.versionen.seitVersion' | translate: { version: vonVersion() } }}
      @if (autor()) {
        · {{ autor() }}
      }
      @if (geaendertAm()) {
        · {{ geaendertAm() | date: zeitMuster }}
      }
    </p>
    @if (felder().length) {
      <div class="version-diff-list__bloecke">
        @for (feld of felder(); track $index) {
          <div class="version-diff-list__block">
            <div class="version-diff-list__block-kopf">{{ feld.label }}</div>
            <div class="version-diff-list__zeile version-diff-list__zeile--vorher">
              <span
                class="version-diff-list__zeichen"
                role="img"
                [attr.aria-label]="'common.detailsHistorie.versionen.vorher' | translate"
              >
                −
              </span>
              <span class="version-diff-list__wert">{{ wert(feld.vorher) }}</span>
            </div>
            <div class="version-diff-list__zeile version-diff-list__zeile--nachher">
              <span
                class="version-diff-list__zeichen"
                role="img"
                [attr.aria-label]="'common.detailsHistorie.versionen.aktuell' | translate"
              >
                +
              </span>
              <span class="version-diff-list__wert">{{ wert(feld.nachher) }}</span>
            </div>
          </div>
        }
      </div>
    }
  </div>
} @else {
  <p class="version-diff-list__leer">{{ 'common.detailsHistorie.versionen.leer' | translate }}</p>
}
